import {
  FormFieldType,
  FormQuestion,
} from "../event-page-models/form-question";

export const createParentEventFormQuestionsContent: Record<
  | "parentEventDetailsQuestions"
  | "parentEventPricingQuestions"
  | "parentEventAdvancedDetailsQuestions"
  | "childEventAdvancedDetailsQuestions",
  FormQuestion[]
> = {
  parentEventPricingQuestions: [
    {
      fieldName: "eventBasePrice",
      placeHolder: "",
      selectItems: [],
      label: "מחיר ארוע",
      order: 0,
      isRequired: true,
      fieldType: FormFieldType.Number,
      value: true,
    },
  ],
  parentEventDetailsQuestions: [
    {
      fieldName: "eventName",
      placeHolder: "",
      selectItems: [],
      label: "שם הארוע",
      order: 0,
      isRequired: true,
      fieldType: FormFieldType.Text,
      value: "",
    },
    {
      fieldName: "eventType",
      placeHolder: "",
      label: "סוג הארוע",
      selectItems: [{ key: "hike", text: "שגיאה", customValue: "" }],
      order: 0,
      isRequired: true,
      fieldType: FormFieldType.Select,
      value: "",
    },
    {
      fieldName: "eventStartDate",
      placeHolder: "",
      selectItems: [],
      label: "תאריך תחילת הארוע",
      order: 0,
      isRequired: true,
      fieldType: FormFieldType.Date,
      value: "",
      customStyle: "half-row",
    },
    {
      fieldName: "eventStartHour",
      placeHolder: "",
      selectItems: [],
      label: "שעת תחילת הארוע",
      order: 0,
      isRequired: true,
      fieldType: FormFieldType.Hour,
      value: "",
      customStyle: "half-row",
    },
    {
      fieldName: "eventEndDate",
      placeHolder: "",
      selectItems: [],
      label: "תאריך סיום הארוע",
      order: 0,
      isRequired: true,
      fieldType: FormFieldType.Date,
      value: "",
      customStyle: "half-row",
    },
    {
      fieldName: "eventEndHour",
      placeHolder: "",
      selectItems: [],
      label: "שעת סיום הארוע",
      order: 0,
      isRequired: true,
      fieldType: FormFieldType.Hour,
      value: "",
      customStyle: "half-row",
    },
    {
      fieldName: "registrationStartDate",
      placeHolder: "",
      selectItems: [],
      label: "תאריך תחילת הרשמה",
      order: 0,
      isRequired: true,
      fieldType: FormFieldType.Date,
      value: "",
      customStyle: "half-row",
    },
    {
      fieldName: "registrationEndDate",
      placeHolder: "",
      selectItems: [],
      label: "תאריך סיום הרשמה",
      order: 0,
      isRequired: true,
      fieldType: FormFieldType.Date,
      value: "",
      customStyle: "half-row",
    },

    {
      fieldName: "eventDescription",
      placeHolder: "",
      selectItems: [],
      label: "תיאור הארוע",
      order: 0,
      isRequired: true,
      fieldType: FormFieldType.LongText,
      value: "",
    },
    {
      fieldName: "closedToMembers",
      placeHolder: "",
      selectItems: [],
      label: "סגור דמי חבר",
      order: 0,
      isRequired: false,
      fieldType: FormFieldType.Checkbox,
      value: "",
    },
    {
      fieldName: "brothersDiscount",
      placeHolder: "",
      selectItems: [],
      label: " הנחת אחים",
      order: 0,
      isRequired: false,
      fieldType: FormFieldType.Checkbox,
      value: "",
    },
    {
      fieldName: "brothersDiscountPeriod",
      placeHolder: "",
      selectItems: [],
      label: " תקופת הרשמה להנחת אחים",
      order: 0,
      isRequired: false,
      fieldType: FormFieldType.Select,
      value: "",
    },
    {
      fieldName: "eventCollection",
      placeHolder: "",
      selectItems: [],
      selectedMultipleOptions: [],
      label: "אוסף ארועים",
      order: 0,
      isRequired: false,
      fieldType: FormFieldType.MultiSelect,
      value: "",
    },
  ],
  parentEventAdvancedDetailsQuestions: [
    {
      fieldName: "eventIndex",
      placeHolder: "",
      selectItems: [],
      label: " אינדקס",
      order: 0,
      isRequired: false,
      fieldType: FormFieldType.Text,
      value: "",
    },
    {
      fieldName: "gainCenter1",
      placeHolder: "",
      selectItems: [],
      label: " מרכז רווח 1",
      order: 0,
      isRequired: false,
      fieldType: FormFieldType.Text,
      value: "",
      customStyle: "half-row",
    },
    {
      fieldName: "gainCenter3",
      placeHolder: "",
      selectItems: [],
      label: " מרכז רווח 3",
      order: 0,
      isRequired: false,
      fieldType: FormFieldType.Text,
      value: "",
      customStyle: "half-row",
    },
  ],
  childEventAdvancedDetailsQuestions: [
    {
      fieldName: "eventCode",
      placeHolder: "",
      selectItems: [],
      label: " קוד ארוע בן",
      order: 0,
      isRequired: false,
      fieldType: FormFieldType.Text,
      value: "",
      customAttributes: {
        alwaysDisabled: true,
        hideIfNoValue: true,
        alwaysHide: false,
      },
    },
    {
      fieldName: "eventDescription",
      placeHolder: "",
      selectItems: [],
      label: "תאור הארוע",
      order: 0,
      isRequired: false,
      fieldType: FormFieldType.LongText,
      value: "",
    },

    {
      fieldName: "eventStartDate",
      placeHolder: "",
      selectItems: [],
      label: "תאריך תחילת הארוע",
      order: 0,
      isRequired: true,
      fieldType: FormFieldType.Date,
      value: "",
      customStyle: "half-row",
    },
    {
      fieldName: "eventStartHour",
      placeHolder: "",
      selectItems: [],
      label: "שעת תחילת הארוע",
      order: 0,
      isRequired: true,
      fieldType: FormFieldType.Hour,
      value: "",
      customStyle: "half-row",
    },
    {
      fieldName: "eventEndDate",
      placeHolder: "",
      selectItems: [],
      label: "תאריך סיום הארוע",
      order: 0,
      isRequired: true,
      fieldType: FormFieldType.Date,
      value: "",
      customStyle: "half-row",
    },
    {
      fieldName: "eventEndHour",
      placeHolder: "",
      selectItems: [],
      label: "שעת סיום הארוע",
      order: 0,
      isRequired: true,
      fieldType: FormFieldType.Hour,
      value: "",
      customStyle: "half-row",
    },
    {
      fieldName: "registrationStartDate",
      placeHolder: "",
      selectItems: [],
      label: "תאריך תחילת הרשמה",
      order: 0,
      isRequired: true,
      fieldType: FormFieldType.Date,
      value: "",
      customStyle: "half-row",
    },
    {
      fieldName: "registrationEndDate",
      placeHolder: "",
      selectItems: [],
      label: "תאריך סיום הרשמה",
      order: 0,
      isRequired: true,
      fieldType: FormFieldType.Date,
      value: "",
      customStyle: "half-row",
    },
    {
      fieldName: "closedToMembersChildEvent",
      placeHolder: "",
      selectItems: [],
      label: "סגור דמי חבר",
      order: 0,
      isRequired: false,
      fieldType: FormFieldType.Checkbox,
      value: "",
    },
    {
      fieldName: "brothersDiscountChildEvent",
      placeHolder: "",
      selectItems: [],
      label: " הנחת אחים",
      order: 0,
      isRequired: false,
      fieldType: FormFieldType.Checkbox,
      value: "",
    },
    {
      fieldName: "eventCollection",
      placeHolder: "",
      selectItems: [],
      selectedMultipleOptions: [],
      label: "אוסף ארועים",
      order: 0,
      isRequired: false,
      fieldType: FormFieldType.MultiSelect,
      value: "",
    },
  ],
};



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/create-parent-event-form-questions-content/create-parent-event-form-questions-content.ts